import React, { useState, useEffect, useContext } from "react";
import "../Product_Cart.css";
import "../Shop_Now/Shop_Now.css";
import {
  Breadcrumb,
  Button,
  Form,
  Table,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import { faCircleInfo } from "@fortawesome/free-solid-svg-icons";
import { Link, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Cookies from "js-cookie";
import { useForm, Controller, SubmitHandler } from "react-hook-form";
import classNames from "classnames";
import CoupanModal from "../../Common_modal/coupon_modal/couponModal";
import CouponModal from "../../Common_modal/CouponModal/CouponModal";

import { Context } from "../../../utils/context";

import {
  CartQuantity,
  deleteCart,
  getCart,
} from "../../../utils/apis/addToCart/addToCart";

import { getCouponCode } from "../../../utils/apis/orderProcess/orderProcess";
import { Errors } from "../../../utils/errors";
import { useLocation } from "react-use";
import { getAppSetup } from "../../../utils/apis/common/Common";
import axios from "axios";

const Cart = ({
  type,
  amount,
  setAmount,
  // discount,
  // setDiscount,
  coupon,
  setCoupon,
  setTotalTax,
  tax,
  setDeliveryInstruction,
}) => {
  const navigate = useNavigate();
  const {
    IMG_URL,
    signin,
    triggerCartUpdate,
    setopen_delivery,
    open_delivery,
    setquick_delivery,
    quick_delivery,
    appSetup,
    setAppSetup,
    setSellerPincode,
    sellerPincode,
    deliveryPincode,
    outOfStock,
    userdata,
    setDiscount,
    discount,
  } = useContext(Context);

  const getDistance = async (sellerPin, deliveryPin) => {
    const apiKey = "AIzaSyAGSck_G-HPj42U4xyH4jOnmjPm1HgQ9Fk";
    // const url = `https://maps.googleapis.com/maps/api/directions/json?origin=${sellerPin}&waypoints=optimize:true|&destination=${deliveryPin}&key=${apiKey}&mode=driving&language=en&region=undefined%22`;
    const url = `https://maps.googleapis.com/maps/api/distancematrix/json?units=metric&origins=${sellerPin}&destinations=${deliveryPin}&key=${apiKey}`;

    try {
      const response = await axios.get(url);

      const data = response.data;

      if (data.status === "OK") {
        const distance = data.rows[0].elements[0].distance.text;

        return distance;
      } else {
        console.error("Error in API response:", data.status);
        return null;
      }
    } catch (error) {
      console.error("Error fetching distance:", error);
      return null;
    }
  };

  //   try {
  //     const result = await axios.get(
  //       `https://maps.googleapis.com/maps/api/directions/json?origin=${StartLat},${StartLong}&waypoints=optimize:true|&destination=${EndLat},${EndLong}&key=${GOOGLE_MAPS_API_KEY}&mode=driving&language=en&region=undefined%22`,
  //     );
  //     console.info(
  //       JSON.stringify({StartLat, StartLong, EndLat, EndLong, result}),
  //     );
  //     return result;
  //   } catch (error) {
  //     console.warn({error});
  //     return error?.response;
  //   }
  // }

  useEffect(() => {
    const fetchDistance = async () => {
      const distance = await getDistance(sellerPincode, deliveryPincode);
    };

    fetchDistance();
  }, [sellerPincode, deliveryPincode]);

  const {
    control,
    register,
    handleSubmit,
    getValues,
    setError,
    clearErrors,
    formState: { errors },
    reset,
    trigger,
  } = useForm();

  const appSetupGet = async () => {
    const res = await getAppSetup();
    if (res?.success) {
      setAppSetup(res?.data);
    }
  };

  useEffect(() => {
    appSetupGet();
  }, []);

  const location = useLocation();
  var [grandTotal, setGrandTotal] = useState(0);
  var [message, setMessage] = useState("");
  const [modalShow, setModalShow] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [couponStatus, setCouponStatus] = useState(false);
  const [copyCode, setCopyCode] = useState("");
  const [cardError, setCardError] = useState();
  const [couponErrors, setCouponError] = useState("");
  const [modalShowCoupon, setModalShowCoupon] = useState(false);
  const [error, setErrors] = useState({});

  const [cart, setCart] = useState([]);

  const [saleError, setSaleError] = useState(false);
  const showButton = location.pathname !== "/product-cart-details";

  const [allCoupon, setAllCoupon] = useState(false);
  let totalAmount = 0;
  let totalPrice = 0;

  let totalTax = 0;

  const handleDeleteRecord = async (id) => {
    const response = await deleteCart(id);

    if (response?.success) {
      setModalShow(true);
      await getCartQuantity();
      setTimeout(() => {
        setModalShow(false);
      }, 2000);
      cartGet();
    } else {
      console.error("Failed to delete the record");
    }
  };

  // const handleOpenModal = () => {
  //   if (cart?.[0]?.product?.sale === 1) {
  //     setSaleError("Coupon not applicable on sale items");
  //     return;
  //   }
  //   setShowModal(true);
  // };

  const handleOpenModal = () => {
    const anySaleProduct = cart.some((item) => item?.product?.sale === 1);

    if (anySaleProduct) {
      setSaleError("Coupon not applicable on sale items");
      return;
    }

    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const product_id = cart?.map((value) => value?.product_id);
  const varient_amount = cart?.map(
    (value) =>
      value?.product_variant?.s_price * value.quantity ||
      value?.product_multiple_variant?.s_price * value.quantity
  );

  useEffect(() => {
    if (cart.length > 0) {
      setSellerPincode(cart[0].product?.user?.store_detail?.pincode?.name);
    }
    setDiscount(0);
  }, [cart]);

  const getCartQuantity = async (id, type, quantity) => {
    setError("code", "");

    await CartQuantity(id, type);
    if (Cookies.get("dhaga_cart")) {
      if (JSON.parse(Cookies.get("dhaga_cart")).length === 0) {
        navigate("/shop-now");
      }
      setCart(JSON.parse(Cookies.get("dhaga_cart")));
      withoutCart();
    }
    setDiscount(0);
    setCoupon("");
    setCopyCode("");
    setCouponStatus(false);
    reset();

    if (signin) {
      await cartGet();
    }
    triggerCartUpdate();
  };

  const cartGet = async () => {
    const res = await getCart();
    if (res?.success) {
      if (res?.data.length === 0) {
        navigate("/shop-now");
      }
      setCart(res?.data);
    }
  };

  const withoutCart = async () => {
    if (Cookies.get("dhaga_cart")) {
      if (JSON.parse(Cookies.get("dhaga_cart")).length === 0) {
        navigate("/shop-now");
      }
      await setCart(JSON.parse(Cookies.get("dhaga_cart")));
    }
  };

  useEffect(() => {
    if (signin) {
      cartGet();
    } else {
      withoutCart();
    }
  }, [Cookies.get("dhaga_cart"), signin]);

  useEffect(() => {
    cartGet();
  }, []);

  // const handleNavigate = async (product_id) => {
  //   localStorage.setItem("product_id", product_id);
  //   navigate(`/vendor-page/${product_id}`);
  // };

  const handleNavigate = async (product_id, variant_id) => {
    await localStorage.setItem("product_id", product_id);
    await localStorage.setItem("variant_id", variant_id);

    await navigate(`/vendor-page/${product_id}?variant_id=${variant_id}`);
  };

  const handleChange = (e) => {
    const instruction = e.target.value;

    setDeliveryInstruction(instruction);
  };

  return (
    <>
      {cart.length > 0 ? (
        <div className="row">
          <div className="col-xxl-9 col-xl-9 col-lg-8">
            <div className="product_table">
              {signin
                ? cart?.map((value, index) => {
                    totalPrice +=
                      (value?.product_variant?.mrp
                        ? value.product_variant.mrp
                        : value?.product_multiple_variant?.mrp) *
                      value?.quantity;
                    totalTax +=
                      (value?.product_variant?.mrp
                        ? value.product_variant.mrp -
                          value.product_variant.s_price
                        : value?.product_multiple_variant?.mrp -
                          value?.product_multiple_variant?.s_price) *
                      value?.quantity;

                    return (
                      <div className="row tabless mb-5">
                        <div className="col-xxl-2 col-xl-2  col-lg-3 col-md-3 col-sm-3 col-4">
                          <div
                            className="cabbageimg"
                            onClick={() =>
                              handleNavigate(
                                value?.product_id,
                                value?.variant_id
                              )
                            }>
                            <img
                              src={IMG_URL + value?.product?.image1}
                              className="cartimg"
                            />
                          </div>
                        </div>
                        <div className="col-xxl-10 col-xl-10 col-lg-9 col-md-9 col-sm-9 col-8">
                          <div className="row">
                            <div className="col-md-12">
                              <div className="prices">
                                <p className="cabbage ">
                                  {value?.product?.name}({" "}
                                  {value?.product_variant?.v_name
                                    ? value.product_variant.v_name
                                    : value?.product_multiple_variant
                                        ?.varient_sub_name}
                                  )
                                </p>
                              </div>
                            </div>

                            <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12 ">
                              <div className="prices">
                                <p className="prce me-2">
                                  Selling Price :{" "}
                                  <div className="price_holder">
                                    <span>
                                      ₹
                                      {value?.product_variant?.mrp
                                        ? value?.product_variant?.mrp
                                        : value?.product_multiple_variant?.mrp}
                                    </span>

                                    <span className="mrp_price">
                                      ₹
                                      {value?.product_variant?.cutting_price
                                        ? value?.product_variant?.cutting_price
                                        : value?.product_multiple_variant
                                            ?.cutting_price}
                                    </span>
                                  </div>
                                </p>

                                <p className="prce me-2">
                                  Base Price :{" "}
                                  <div className="price_holder">
                                    <span>
                                      ₹
                                      {value?.product_variant?.s_price
                                        ? value?.product_variant?.s_price
                                        : value?.product_multiple_variant
                                            ?.s_price}
                                    </span>

                                    {/* <span className="mrp_price">
                                      ₹
                                      {value?.product_variant?.cutting_price
                                        ? value?.product_variant?.cutting_price
                                        : value?.product_multiple_variant
                                            ?.cutting_price}
                                    </span> */}
                                  </div>
                                </p>

                                <p className="prce">
                                  Tax :{" "}
                                  <span>
                                    ₹
                                    {(
                                      (value?.product_variant?.mrp
                                        ? value?.product_variant?.mrp -
                                          value?.product_variant?.s_price
                                        : value?.product_multiple_variant?.mrp -
                                          value?.product_multiple_variant
                                            ?.s_price) * value?.quantity
                                    ).toFixed(2)}
                                  </span>
                                </p>
                              </div>
                            </div>

                            <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-2 col-sm-2 col-0 "></div>

                            <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12">
                              <div className="prices">
                                {/* <p className="cabbage cabbage2">{value?.product?.name}</p> */}
                                <p className="prce">
                                  Total Price:{" "}
                                  <span>
                                    ₹
                                    {value?.product_variant?.mrp
                                      ? (
                                          value?.product_variant?.mrp *
                                          value?.quantity
                                        ).toFixed(2)
                                      : (
                                          value?.product_multiple_variant?.mrp *
                                          value?.quantity
                                        ).toFixed(2)}
                                    {/* {(
                                      value?.product_multiple_variant?.mrp?value?.product_multiple_variant?.mrp: *
                                        value?.quantity +
                                      (value?.product?.product_detail
                                        ?.tax_percentage?.name *
                                        (value?.product_multiple_variant
                                          ?.mrp *
                                          value?.quantity)) /
                                        100
                                    ).toFixed(2)} */}
                                  </span>
                                </p>
                                {location.pathname == "/product-cart" && (
                                  <div className="qnty">
                                    <p className="prce mb-0">Quantity:</p>
                                    <div className="counting">
                                      <button
                                        className="count-btn"
                                        type="button"
                                        onClick={async () => {
                                          await getCartQuantity(
                                            value?.id,
                                            "minus"
                                          );
                                          await cartGet();
                                        }}>
                                        <FontAwesomeIcon
                                          icon="fa-solid fa-minus"
                                          className="minnusicns"
                                        />
                                      </button>
                                      <p className=" prce nombers">
                                        {value?.quantity}
                                      </p>

                                      <button
                                        className="count-btn"
                                        type="button"
                                        onClick={async () => {
                                          const maxStock = Number(
                                            value?.product_variant?.unit ?? 0
                                          );
                                          const currentQty = Number(
                                            value?.quantity ?? 0
                                          );

                                          if (currentQty >= maxStock) {
                                            setErrors((prev) => ({
                                              ...prev,
                                              [value.id]: `Only ${maxStock} in stock`,
                                            }));
                                            return;
                                          }

                                          await getCartQuantity(
                                            value?.id,
                                            "add"
                                          );
                                          setErrors({});
                                          await cartGet();
                                        }}>
                                        +
                                      </button>
                                    </div>

                                    <p className="error_text">
                                      {error[value.id] && (
                                        <p
                                          className="text-danger mt-1"
                                          style={{ fontSize: "13px" }}>
                                          {error[value.id]}
                                        </p>
                                      )}
                                    </p>
                                    <div className="col-xxl-2 col-xl-2 col-lg-3 col-md-3 col-sm-4 col-5  trash-icon-holder">
                                      <div className="prices">
                                        <p className="cabbage cabbage2"></p>
                                        <p className="prce">
                                          <span></span>
                                        </p>
                                        <button
                                          className="count-btn trash-icon_btn"
                                          type="button"
                                          onClick={() =>
                                            handleDeleteRecord(value?.id)
                                          }>
                                          <FontAwesomeIcon
                                            icon="fa-solid fa-trash"
                                            className=" trash-icon"
                                          />
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })
                : cart?.map((value, index) => {
                    console.log(value, "valuevalue");

                    totalPrice += value?.mrp * value?.quantity;

                    totalTax +=
                      value?.mrp * value?.quantity -
                      value?.price * value?.quantity;

                    return (
                      <div className="row tabless mb-4">
                        <div className="col-xxl-2 col-xl-2  col-lg-3 col-md-3 col-sm-3 col-4">
                          <div
                            className="cabbageimg"
                            onClick={() => handleNavigate(value?.product_id)}>
                            <img
                              src={IMG_URL + value?.image}
                              className="cartimg"
                            />
                          </div>
                        </div>
                        <div className="col-xxl-10 col-xl-10 col-lg-9 col-md-9 col-sm-9 col-8">
                          <div className="row">
                            <div className="col-md-12">
                              <div className="prices">
                                <p className="cabbage ">
                                  {value?.name} ({value?.size})
                                </p>
                              </div>
                            </div>
                            <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12 ">
                              <div className="prices">
                                <p className="prce me-2">
                                  Selling Price : <span>₹{value?.mrp}</span>
                                </p>

                                <p className="prce me-2">
                                  Base Price : <span>₹{value?.price}</span>
                                </p>

                                <p className="prce">
                                  Tax :{" "}
                                  <span>
                                    <span>
                                      ₹
                                      {(
                                        value?.mrp * value?.quantity -
                                        value?.price * value?.quantity
                                      ).toFixed(2)}
                                    </span>
                                  </span>
                                </p>
                              </div>
                            </div>
                            <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12 "></div>
                            <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12">
                              <div className="prices">
                                {/* <p className="cabbage cabbage2">{value?.product?.name}</p> */}
                                <p className="prce">
                                  Total Price:{" "}
                                  <span>
                                    ₹{(value?.mrp * value?.quantity).toFixed(2)}
                                  </span>
                                </p>
                                <div className="qnty">
                                  <p className="prce mb-0">Quantity:</p>
                                  <div className="counting">
                                    <div className="info_text_holder">
                                      <div className="btn_holder">
                                        <button
                                          className="count-btn"
                                          type="button"
                                          onClick={async () => {
                                            await getCartQuantity(
                                              value?.id,
                                              "minus"
                                            );
                                            setErrors("");
                                            await cartGet();
                                            const maxStock = Number(
                                              value?.unit ?? 0
                                            );
                                            const currentQty = Number(
                                              value?.quantity ?? 0
                                            );

                                            setErrors({});
                                          }}>
                                          <FontAwesomeIcon
                                            icon="fa-solid fa-minus"
                                            className="minnusicns"
                                          />
                                        </button>
                                        <p className=" prce nombers">
                                          {value?.quantity}
                                        </p>
                                        <button
                                          className="count-btn"
                                          type="button"
                                          onClick={async () => {
                                            const maxStock = Number(
                                              value?.unit ?? 0
                                            );
                                            const currentQty = Number(
                                              value?.quantity ?? 0
                                            );

                                            if (currentQty >= maxStock) {
                                              setErrors((prev) => ({
                                                ...prev,
                                                [value.id]: `Only ${maxStock} in stock`,
                                              }));
                                              return;
                                            }

                                            await getCartQuantity(
                                              value?.id,
                                              "add",
                                              value?.quantity
                                            );
                                            setErrors({});
                                            await cartGet();
                                          }}>
                                          <FontAwesomeIcon
                                            icon="fa-solid fa-plus"
                                            className="plusicns"
                                          />
                                        </button>
                                      </div>

                                      <p className="error_text">
                                        {error[value.id] && (
                                          <p
                                            className="text-danger mt-1"
                                            style={{ fontSize: "13px" }}>
                                            {error[value.id]}
                                          </p>
                                        )}
                                      </p>
                                    </div>
                                  </div>

                                  <div className="col-xxl-2 col-xl-2 col-lg-3 col-md-3 col-sm-4 col-5  trash-icon-holder">
                                    <div className="prices">
                                      <p className="cabbage cabbage2"></p>
                                      <p className="prce">
                                        <span></span>
                                      </p>
                                      {/* <button
                                        className="count-btn trash-icon_btn"
                                        type="button"
                                        onClick={() => setModalShow(true)}
                                      >
                                        <FontAwesomeIcon
                                          icon="fa-solid fa-trash"
                                          className=" trash-icon"
                                        />
                                      </button> */}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
            </div>
            <Link to={"/"}>
              <div className="Continue_Shopping_text">
                <p>Continue Shopping</p>
              </div>
            </Link>
          </div>

          <div className="col-xxl-3 col-xl-3 col-lg-4">
            <div className="grand_total_table">
              <div className="orderss">
                <h6 className="ordersum">Order Summary</h6>
              </div>
              <Table responsive>
                <thead>
                  <tr className="top-border">
                    <th>Sub Total Amount</th>
                    <td>
                      ₹
                      {Number(totalPrice).toFixed(2) -
                        Number(totalTax).toFixed(2)}{" "}
                    </td>
                  </tr>
                </thead>
                {(discount || couponStatus) && (
                  <thead>
                    <tr>
                      <th>Coupon Discount</th>
                      <td>₹{discount}</td>
                    </tr>
                  </thead>
                )}

                <thead>
                  <tr className="top-border">
                    <th>Tax</th>
                    <td>₹{totalTax.toFixed(2)}</td>
                  </tr>
                </thead>

                {location.pathname === "/product-cart-details" &&
                  signin &&
                  !cart.some((item) => item?.product?.sale === 1) && (
                    <tr className="Coupon_code_holder top-border">
                      <td colSpan={2}>
                        <div className="button-holder">
                          {discount || couponStatus ? (
                            <Button
                              className="Checkout_btn"
                              type="button"
                              onClick={() => {
                                setDiscount(0);
                                setCoupon("");
                                setCopyCode("");
                                setCouponStatus(false);
                                reset();
                              }}>
                              Remove Coupon
                            </Button>
                          ) : (
                            <>
                              {saleError && (
                                <p className="text-danger mb-0">{saleError}</p>
                              )}

                              <Button
                                className="Checkout_btn"
                                type="button"
                                onClick={handleOpenModal}>
                                Apply Coupon
                              </Button>

                              {signin && (
                                <CoupanModal
                                  setCopyCode={setCopyCode}
                                  show={showModal}
                                  setError={setError}
                                  getCouponCode={getCouponCode}
                                  varient_amount={varient_amount}
                                  handleClose={handleCloseModal}
                                  product_id={product_id}
                                  setCardError={setCardError}
                                  setCouponStatus={setCouponStatus}
                                  setDiscount={setDiscount}
                                  setCouponError={setCouponError}
                                  setMessage={setMessage}
                                  message={message}
                                  setModalShowCoupon={setModalShowCoupon}
                                  setCoupon={setCoupon}
                                  coupon={coupon}
                                  totalPrice={totalPrice}
                                  totalAmount={totalAmount}
                                  couponErrors={couponErrors}
                                  variant_id={cart?.[0]?.variant_id}
                                  m_variant_id={cart?.[0]?.m_variant_id}
                                  quantity={cart[0]?.quantity}
                                  setAllCoupon={setAllCoupon}
                                  allCoupon={allCoupon}
                                />
                              )}
                            </>
                          )}
                        </div>
                      </td>
                    </tr>
                  )}

                {type === "checkout" && (
                  <thead>
                    <tr>
                      <td colSpan={2}>
                        <sup
                          className="text-danger"
                          style={{ fontSize: "1.2em" }}>
                          {errors?.code?.message}
                        </sup>
                      </td>
                    </tr>
                  </thead>
                )}
                <CouponModal
                  show={modalShow}
                  onHide={() => setModalShow(false)}
                  message={`Cart Deleted Successfully`}
                />

                <thead>
                  <tr className="bottom-border">
                    <th className="bold-text">Total</th>
                    <td className="bold-text">
                      ₹
                      <span>
                        {Number(Math.round(totalPrice)) - discount}
                        {setAmount(totalPrice - discount)}
                        .00
                      </span>
                      <p>
                        (Includes all Taxes
                        {/* {","}
                        <Link to={"/terms-conditions"}>
                          Terms & Condition
                        </Link>{" "} */}
                        )
                      </p>
                    </td>
                  </tr>
                </thead>
              </Table>
            </div>

            {location.pathname == "/product-cart-details" && (
              <div className="instruction-field-holder mt-4">
                <Form.Group
                  className="mb-3"
                  controlId="exampleForm.ControlTextarea1">
                  <Form.Label>
                    <b>Add Delivery Instruction</b>
                  </Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    onChange={handleChange}
                  />
                </Form.Group>
              </div>
            )}

            <div className="row justify-content-end mb-3">
              <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-6">
                <div className="button-holder text-end">
                  {showButton && (
                    <Link to={signin ? "/product-cart-details" : "/login"}>
                      <Button className="procheckout_btn" type="button">
                        Proceed to Checkout
                      </Button>
                    </Link>
                  )}
                </div>
              </div>
            </div>

            {/* <h3>{outOfStock}</h3> */}
          </div>
        </div>
      ) : (
        <section className="Empty_Cart">
          <div className="container-fluid">
            <div className="row justify-content-center">
              <div className="col-xl-3 col-lg-5 col-md-6 col-sm-7 col-10">
                <div className="shop-now-content">
                  <div className="img-holder">
                    <img
                      src={
                        process.env.PUBLIC_URL +
                        "/assets/Image/Cash_On_Delivery_Process/basket.png"
                      }
                      className="basket_img"
                    />
                  </div>
                  <div className="heading_holder mt-3">
                    <h5>Your cart is Empty</h5>
                    <p>
                      You have no items in your shopping cart. Let's go buy
                      something
                    </p>
                    <div className="main-btn-div">
                      <Link to={"/"}>
                        <button className="back-btn" type="button">
                          Shop Now
                        </button>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}
      {/* <CoupanModal
                show={showModal}
                handleClose={handleCloseModal}
            /> */}
    </>
  );
};

export default Cart;
